import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classes from './InvoiceWarningIcon.module.scss'
import clsx from 'clsx'

interface InvoiceWarningIconProps {
  onClick?: () => void
  title?: string
  showClickableUI?: boolean
}
export default function InvoiceWarningIcon({
  onClick,
  title,
  showClickableUI,
}: InvoiceWarningIconProps) {
  return (
    <>
      <FontAwesomeIcon
        icon={faExclamationCircle}
        className={clsx(classes['custom-icon'], { 'gmawb-clickable-ui': showClickableUI })}
        onClick={onClick}
        title={title}
      />
    </>
  )
}
